import { isCausedByNetworkFailure } from 'shared/utils/errorHandling';
import { logError } from './logError';
import { logInfo } from './logInfo';

/**
 * Logs a failure as an error, or as info when it was caused by a request that
 * never reached the server: a lost network (offline, laptop asleep) is not a
 * fault of the app.
 */
export function logErrorUnlessNetworkFailure(
  message: string,
  error: unknown,
  context: Record<string, unknown> = {}
): void {
  const log = isCausedByNetworkFailure(error) ? logInfo : logError;
  log(message, { error, ...context });
}
